import apiHub from "../services/apiHub";
import getHeadersHub from "../utils/returnHeadersHub";

export default class CarRepository {
  searchAutoComplete = (name) => {
    const header = getHeadersHub();

    return apiHub.post(
      `/api/services/car/auto-complete/`,
      {
        filter: {
          name: name,
        },
      },
      header,
    );
  };

  search = (filter) => {
    const header = getHeadersHub();

    return apiHub.post(
      `/api/services/car/search/`,
      {
        filter: filter,
      },
      header,
    );
  };

  checkRate = async (filter) => {
    const header = getHeadersHub();

    return apiHub.post(
      `/api/services/car/get/`,
      {
        filter: filter,
      },
      header,
    );
  };

  booking = async (data) => {
    const header = getHeadersHub();

    return apiHub.post(`/api/services/car/booking/`, data, header);
  };
}
